import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';

import IconClose from '../../assets/svg/x.svg';

@Component<Modal>({
  components: {
    IconClose
  },
  data() {
    return {
      open: this.$props.isOpen
    }
  }
})
export default class Modal extends Vue {
  @Prop({ type: String })
  title!: string;

  @Prop({ type: String })
  modalWidth!: string;

  @Prop({ type: Boolean })
  isOpen!: boolean;

  get hasSlot(): boolean {
    return !!this.$slots.default;
  }

  close(e: Event): void {
    e.preventDefault();
    e.stopPropagation();

    this.$emit('close', e);
  }

  @Watch('isOpen')
  updateState(val: boolean): void {
    this.$data.open = val;
  }
}
